import React from 'react';
import PropTypes from 'prop-types';

import { useRouterProps } from './withRouter';


// Equivalent of <Route component={...} /> from react-router v4: renders the
// page component with `location`, `match` and `history` props.
const RouteComponent = ({ component: Component, ...rest }) => {
  const routerProps = useRouterProps();
  return <Component {...routerProps} {...rest} />;
};

RouteComponent.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export const routeElement = (Component, props = {}) => <RouteComponent component={Component} {...props} />;

export default RouteComponent;
